module.exports = __webpack_public_path__ + "static/good-managers-bb347103880a5591d095ddea19a635fa.jpg";